module.exports = __webpack_public_path__ + "img/login-illustration.430a6964.svg";